import { createSelector } from 'reselect'

export const getCartCurrentHistoryItem = createSelector(
  (state) => state && state.cart && state.cart.history && state.cart.history.currentItem,
  currentItem => currentItem
)
